<!-- @if (!subscriptionOverview.subscriptionId()) {
<mat-spinner class="spinner" diameter="40" color="primary"></mat-spinner>
} -->
<div class="content">
    <div class="side-menu" style="overflow: auto;">
        <div>
            <button class="addbutton" (click)="newWorkflow()">
                <mat-icon>add</mat-icon>
                <span>{{'NewContract' | translate }}</span>
            </button>
        </div>

        @for (workflow of subscriptionOverview.workflowOverview(); track workflow) {
        @if (workflow.contentCollectionType == "contract") {
        <div class="workflow-option" (click)="openWorkflow(workflow.uid)">
            <a>
                <span> {{workflow.name}}</span>
                <div>
                    <mat-icon (click)="deleteWorkflow(workflow.uid)">delete</mat-icon>
                </div>
            </a>
        </div>
        }
        }
    </div>

    <div class="workflow-content">
        @if (!selectedWorkflowId) {
        <div id="workflow-area">
            <div id="workflows">
                <div class="workflow-placeholder">
                    <img [src]="dora_logo" alt="Logo" />
                    <p class="mt-3">
                        {{'Welcome' | translate}}
                        <b>DORA</b>
                    </p>
                    <p>{{'StartUploadingContract' | translate }} </p>
                </div>
            </div>
        </div>
        }

        @if (selectedWorkflowId) {
        <workflow-view [workflowId]="selectedWorkflowId"></workflow-view>
        }
    </div>
</div>